<template>
  <div class="w-full pb-2 flex flex-col justify-start items-start gap-[15px]">
    <!-- Tabs Section -->
    <div class="w-full flex justify-start items-start gap-[11px]">
      <button
        v-if="hasPermission('User_View')"
        :class="[
          'text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px]',
          {
            'border-b-2 border-[#2463EB] text-[#2463EB]':
              activeTabProp === 'user',
            'text-[#96a0b5]': activeTabProp !== 'user',
          },
        ]"
        @click="switchTab('user')"
      >
        User Management
      </button>
      <button
        v-if="hasPermission('Role_View')"
        :class="[
          'text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px]',
          {
            'border-b-2 border-[#2463EB] text-[#2463EB]':
              activeTabProp === 'role',
            'text-[#96a0b5]': activeTabProp !== 'role',
          },
        ]"
        @click="switchTab('role')"
      >
        Role Management
      </button>
    </div>

    <!-- User Management Content -->
    <div
      v-if="activeTabProp === 'user'"
      class="flex xs:flex-col lg:flex-row xs:justify-start lg:justify-between w-full xs:items-start xs:gap-4 lg-gap-2 lg:items-center"
    >
      <p class="text-[#353535] text-[14px] leading-[20px] font-semibold">
        Manage All user accounts here
      </p>
      <div
        class="flex gap-[2px] md:gap-3 flex-wrap xs:justify-start lg:justify-center xs:items-start lg:items-center"
      >
        <button
          @click="$emit('viewFilter')"
          class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-normal border-solid text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
        >
          <span class="feather icon-filter text-[#96a0b5]"></span> Filters
        </button>
        <button
          v-if="
            (hasPermission('Sales_Team_Create') ||
              hasPermission('User_Create')) &&
              user.type == 'Distributor'
          "
          class="border-[1px] bg-[#7367f0] rounded-[8px] text-white font-normal border-solid text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
          @click="$emit('viewAdd')"
        >
          <span class="feather icon-plus text-white"></span> Invite User
        </button>
        <button
          v-if="
            (hasPermission('Sales_Team_Create') ||
              hasPermission('User_Create')) &&
              user.type == 'Distributor'
          "
          class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-normal border-solid text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
          @click="$emit('viewAddManual')"
        >
          <i class="feather icon-plus text-white"></i> Create User Manually
        </button>
        <div class="dropdown">
          <button
            v-if="
              (hasPermission('Sales_Team_Create') ||
                hasPermission('User_Create')) &&
                user.type != 'Distributor'
            "
            class="border-[1px] bg-[#7367f0] rounded-[8px] text-white font-normal border-solid text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="feather icon-plus text-white"></span> Invite User
          </button>
          <ul
            class="dropdown-menu shadow-none"
            aria-labelledby="dropdownMenuButton"
          >
            <li
              v-if="hasPermission('Sales_Team_Create')"
              class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer border-b border-[#e5e7eb] py-[12px] px-[16px]"
              @click="$emit('viewSales')"
            >
              Sales Users
            </li>
            <li
              v-if="hasPermission('User_Create')"
              class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer border-b border-[#e5e7eb] py-[12px] px-[16px]"
              @click="$emit('viewAdd')"
            >
              Business Users
            </li>
          </ul>
        </div>
        <div class="dropdown" v-if="user.type != 'Distributor'">
          <button
            v-if="
              hasPermission('Sales_Team_Create') || hasPermission('User_Create')
            "
            class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-normal border-solid text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fa-solid fa-chevron-down"></i> Create User Manually
          </button>
          <ul
            class="dropdown-menu shadow-none"
            aria-labelledby="dropdownMenuButton"
          >
            <li
              v-if="hasPermission('Sales_Team_Create')"
              class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer border-b border-[#e5e7eb] py-[12px] px-[16px]"
              @click="$emit('viewAddSalesManual')"
            >
              Sales User
            </li>
            <li
              v-if="hasPermission('User_Create')"
              class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[12px] px-[16px]"
              @click="$emit('viewAddManual')"
            >
              Business User
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Role Management Content -->
    <div
      v-if="activeTabProp === 'role'"
      class="flex xs:flex-col lg:flex-row xs:justify-start lg:justify-between w-full xs:items-start xs:gap-4 lg-gap-2 lg:items-center"
    >
      <p class="text-[#353535] text-[14px] leading-[20px] font-semibold">
        Manage and assign roles
      </p>
      <button
        v-if="hasPermission('Role_Create') && user.type == 'Distributor'"
        class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-normal border-solid text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
        @click="mansAdd"
      >
        <i class="fa-solid fa-plus"></i> Create New Role
      </button>
      <div class="dropdown" v-if="user.type != 'Distributor'">
        <button
          v-if="
            hasPermission('Role_Create') || hasPermission('Sales_Role_Create')
          "
          class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-normal border-solid text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="fa-solid fa-chevron-down"></i> Create New Role
        </button>
        <ul
          class="dropdown-menu shadow-none"
          aria-labelledby="dropdownMenuButton"
        >
          <li
            class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer border-b border-[#e5e7eb] py-[12px] px-[16px]"
            @click="$emit('viewAddRoleManual')"
            v-if="hasPermission('Sales_Role_Create')"
          >
            Sales Role
          </li>
          <li
            class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[12px] px-[16px]"
            @click="$emit('viewAddBusinessRole')"
            v-if="hasPermission('Role_Create')"
          >
            Business Role
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from "../../main";

export default {
  props: {
    activeTabProp: {
      type: String,
      required: true,
    },
    showManualUserDropdown: Boolean,
    showManualRoleDropdown: Boolean,
    hasPermission: Function,
    refreshUsers: Function,
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },
  methods: {
    switchTab(tab) {
      this.$emit("switchTab", tab);
      if (tab === "user") {
        this.refreshUsers();
      }
    },
    mansAdd() {
      bus.$emit("viewDistRole");
    },
  },
};
</script>
